import React, { useState, useEffect } from "react";
import {
	Text,
	Grid,
	Card,
	Col,
	Button,
} from "@website-builder/ui/shared/elements";
import { ImportantDateCardWrapper } from "./style";
import { isDateValid } from "@website-builder/utilities/utils/utils.js";
import {
	isBusinessVerticalB2U,
	formatDate,
} from "@website-builder/utilities/utils/helpers.js";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";
const isB2U = isBusinessVerticalB2U();
const ImportantDateCard = (props) => {
	const { startLabel, deadlineLabel, timerLabel, pageSection, isCardDark } =
		props;
	const [data, setData] = useState({
		nextDateString: null,
		applicationDeadline: null,
		enrollmentClosesDays: null,
		enrollmentClosesHours: null,
	});

	const TO_BE_ANNOUNCED = "To be announced";

	useEffect(() => {
		const { enrollmentDetailsApiSlug, apiBaseUrl } = props;
		const fetchCourseDetails = async () => {
			const apiEndpoint = `${apiBaseUrl}${enrollmentDetailsApiSlug}`;
			try {
				const response = await fetch(apiEndpoint).then((res) => res.json());
				const {
					application_deadline,
					enrollment_closes_days,
					enrollment_closes_hours,
					next_date_string,
				} = response || {};

				// In case of invalid response:  show the message 'To be announced'
				// Convert enrollment_closes_days & enrollment_closes_hours to string values so that they can be checked for non null values in the render function
				// 0 => false but "0" is true
				const data = {
					nextDateString: isDateValid(next_date_string)
						? next_date_string
						: TO_BE_ANNOUNCED,
					applicationDeadline: isDateValid(application_deadline)
						? formatDate(application_deadline, "MMM d, y")
						: TO_BE_ANNOUNCED,
					enrollmentClosesDays: isNaN(enrollment_closes_days)
						? null
						: `${enrollment_closes_days}`,
					enrollmentClosesHours: isNaN(enrollment_closes_hours)
						? null
						: `${enrollment_closes_hours}`,
					error: false,
				};
				setData(data);
			} catch (err) {
				// In case of error:  show the message 'To be announced'
				setData({
					nextDateString: TO_BE_ANNOUNCED,
					applicationDeadline: TO_BE_ANNOUNCED,
					enrollmentClosesDays: null,
					enrollmentClosesHours: null,
				});
			}
		};

		fetchCourseDetails();
	}, []);
	const { cardColor, title, description, cta = {}, dateCard = [] } = props;
	return (
		<ImportantDateCardWrapper
			isDarkBg={isCardDark}
			className="important-date-card"
		>
			<Grid>
				<Col start={1} span={12} mdStart={1} mdSpan={6}>
					<Card className="card-container" bgColor={cardColor}>
						<Grid className="inner-grid-container">
							<Col start={1} span={5} mdStart={1} mdSpan={6}>
								<Text
									dark={isCardDark}
									className="title"
									variant="headline_3"
									tag="h2"
								>
									{title}
								</Text>
								<Text
									dark={isCardDark}
									className="description"
									variant="paragraph_M"
									tag="div"
									dangerouslySetInnerHTML={{ __html: description }}
								/>
							</Col>
							<Col
								className="right-container"
								start={7}
								span={7}
								mdStart={1}
								mdSpan={6}
							>
								<div className="date-section">
									{data?.nextDateString ? (
										<div className="date-container">
											<Text dark={isCardDark} variant="paragraph_S">
												{startLabel}
											</Text>
											<Text dark={isCardDark} variant="headline_6" tag="p">
												{data?.nextDateString}
											</Text>
										</div>
									) : null}
									{data?.applicationDeadline ? (
										<div className="date-container">
											<Text dark={isCardDark} variant="paragraph_S">
												{deadlineLabel}
											</Text>
											<Text dark={isCardDark} variant="headline_6" tag="p">
												{data?.applicationDeadline}
											</Text>
										</div>
									) : null}
									{data.enrollmentClosesDays && data.enrollmentClosesHours ? (
										<div className="date-container last-container">
											<Text dark={isCardDark} variant="paragraph_S">
												{timerLabel}
											</Text>
											<Text dark={isCardDark} variant="headline_6" tag="p">{`${
												data.enrollmentClosesDays
											} day${data.enrollmentClosesDays > 1 ? "s" : ""}, ${
												data.enrollmentClosesHours
											} hour${data.enrollmentClosesDays > 1 ? "s" : ""}`}</Text>
										</div>
									) : null}
								</div>
								{cta.buttonText ? (
									<Button
										{...cta}
										buttonConfiguration={isB2U && cta}
										buttonText={cta?.buttonText}
										type={cta?.type}
										isDarkBg={cta?.isDarkBg}
										disabled={cta?.disabled}
										onClick={() =>
											handleCTAClick(cta, {
												page_section: pageSection,
												click_text: cta?.buttonText,
												redirect_to: cta?.link?.link,
											})
										}
									/>
								) : null}
							</Col>
						</Grid>
					</Card>
				</Col>
			</Grid>
		</ImportantDateCardWrapper>
	);
};
export default ImportantDateCard;
